/**
 * 내 정보 수정 팝업 Store
 *
 * @since 2018-12-28
 * @author mk.ko
 * ---
 */

import { CommonApiPrefix as apiPrefix } from '~/utils/restApi'

const json2form = params => {
  try {
    const fd = new FormData()
    const keys = Object.keys(params)
    for (const key of keys) {
      fd.append(key, params[key])
    }
    return fd
  } catch (e) {
    this.$log('[Error json2form]:', e)
  }
}
export const state = () => ({
  myAccountInfo: void 0,
  myAccountOtpMenu: []
})

export const mutations = {
  initState (state) {
    state.myAccountInfo = void 0
    state.myAccountOtpMenu = []
  },
  setMyAccountInfo (state, payload) {
    state.myAccountInfo = payload
  },
  setMyAccountOtpMenu (state, payload) {
    // "admin_otp_menu_enable_yn": 0,
    // "admin_otp_menu_id": 0,
    // "admin_otp_menu_name": "string"
    state.myAccountOtpMenu = payload
  }
}

export const actions = {
  async getMyAccountInfo ({ commit }) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$get(`${apiPrefix}/my-account`, {
        ignoreHaPrefix: true
      })

      if (res.code === 'ok') {
        commit('setMyAccountInfo', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async editMyAccountInfo ({ commit }, params) {
    const result = await this.$axios.$put(`${apiPrefix}/my-account`, json2form(params), {
      headers: {
        'Content-type': 'multipart/form-data'
      },
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })
    // successAlert: true
    return result
  },
  async editMyAccountPasswd ({ commit }, params) {
    try {
      const data = await this.$axios.$put(`${apiPrefix}/my-account/passwd`, json2form(params), {
        loading: true,
        successAlert: false,
        ignoreHaPrefix: true
      })
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getMyAccountOtpMenu ({ commit }, { adminId }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${apiPrefix}/managers/otp/${adminId}`)
      if (res.code === 'ok') {
        commit('setMyAccountOtpMenu', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async updateMyAccountOtpMenu ({ commit }, { adminId, otpMenu }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        admin_otp_menu_item: _.map(otpMenu, menu => ({
          admin_otp_menu_id: menu.admin_otp_menu_id,
          admin_otp_menu_enable_yn: menu.admin_otp_menu_enable_yn === true ? 1 : 0
        }))
      }
      res = await this.$axios.$put(`${apiPrefix}/managers/otp/${adminId}`, params)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {
}

export const strict = false
